import {
  HttpContext,
  HttpContextToken,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthFacade, Token } from '@mkp/auth/util';
import { ENVIRONMENT_PROVIDER } from '@mkp/shared/util-environment';
import { map, of, switchMap, take } from 'rxjs';

const PUBLIC_CONTEXT = new HttpContextToken<boolean>(() => false);
export const getPublicContext = (httpContext?: HttpContext) =>
  (httpContext ?? new HttpContext()).set(PUBLIC_CONTEXT, true);

const hasPublicContext = (req: HttpRequest<unknown>) => req.context.get(PUBLIC_CONTEXT);
const isPublicRoute = (req: HttpRequest<unknown>, publicRoutes: string[]): boolean =>
  !!publicRoutes.find((exceptionUrl) => req.url.includes(exceptionUrl));
const isAuthorizedCall = (req: HttpRequest<unknown>, publicRoutes: string[]): boolean =>
  !hasPublicContext(req) && !isPublicRoute(req, publicRoutes);

export const authorizationInterceptor: HttpInterceptorFn = (req, next) => {
  const authFacade = inject(AuthFacade);
  const { network } = inject(ENVIRONMENT_PROVIDER);
  /**
   *
   * @deprecated this is the old way of identifying public calls
   * instead: add the PUBLIC_CONTEXT to the API calls themselves
   */
  const publicRoutes: string[] = [
    '/assets',
    '/benefit',
    '/check-email',
    '/meta',
    '/onboarding',
    '/insight',
    network.jobcloud,
  ];

  return isAuthorizedCall(req, publicRoutes)
    ? authFacade.isAuthenticated$.pipe(
        take(1),
        switchMap((isAuthenticated) =>
          isAuthenticated ? authFacade.token$.pipe(take(1)) : of(null)
        ),
        switchMap((token: Token | null) =>
          isTokenExpired(token) ? authFacade.fetchAccessToken() : of(token)
        ),
        map((token: Token | null) => token?.stringToken),
        map((stringToken) => (stringToken ? addToken(req, stringToken) : req)),
        switchMap((request) => next(request))
      )
    : next(req);
};

const isTokenExpired = (token: Token | null): boolean => !!token && token.expiryDate < new Date();
const addToken = (req: HttpRequest<unknown>, stringToken: string) =>
  req.clone({
    headers: req.headers.set('Authorization', `Bearer ${stringToken}`),
  });
